export * from './inventories.page';
